import React from "react";
import BudgetContainer from "../../components/budget/BudgetContainer";

function budgetPage() {
  return <BudgetContainer />;
}

export default budgetPage;
